import { FeatureHubGuard } from "@/featureFlags";
import { InitDateField } from "@/overlay/components/LayerStackWindow/InitDateField";
import { ColorPicker } from "@/overlay/components/SmartForm/HookInputs/ColorPicker";
import type { PlotSeriesType } from "@/reducer/client-models";
import type { CountryPlotType } from "@/reducer/client-models/CountryPlot";
import { t } from "@lingui/core/macro";
import { useFieldArray } from "react-hook-form";
import type { InputInstruction } from "../../../SmartFormUtils/commonTypeUtils";
import type { CountryPlotFormData } from "../controller";
import { PlotSeriesPanel } from "./PlotSeriesPanel";

type PlotSeriesFieldsArrayProps = {
  instruction: InputInstruction<CountryPlotType["plotSeries"]>;
  submitChange: (index: number, visible: boolean) => void;
};

export function PlotSeriesFieldsArray({ instruction, submitChange }: PlotSeriesFieldsArrayProps) {
  const { formMethods } = instruction;

  const { fields, update } = useFieldArray<CountryPlotFormData>({
    control: formMethods.control,
    name: "plotData.plotSeries",
  });

  const handleSeriesUpdate = (index: number, plotSerie: Partial<PlotSeriesType>) => {
    // @ts-ignore
    const isVisible = fields[index]?.visible ?? true;
    submitChange(index, isVisible);
    update(index, {
      ...fields[index],
      ...plotSerie,
    });
  };

  return (
    <>
      {fields.map((field, index) => (
        <PlotSeriesPanel
          // TODO Fix typing
          // @ts-ignore
          plotSeries={field}
          onUpdateSerie={(plotSerie) => handleSeriesUpdate(index, plotSerie)}
          key={field.id}
        >
          <ColorPicker
            label={t`Color`}
            instruction={{
              // @ts-ignore
              currValue: field.series_color,
              formValueName: `plotData.plotSeries.${index}.series_color`,
              formMethods,
            }}
          />
          <FeatureHubGuard flag="api_url_suffix">
            <InitDateField
              label={t`API URL suffix`}
              defaultValue={(field as PlotSeriesType).api_url_suffix ?? ""}
              onChange={(apiUrlSuffix) => handleSeriesUpdate(index, { api_url_suffix: apiUrlSuffix })}
            />
          </FeatureHubGuard>
        </PlotSeriesPanel>
      ))}
    </>
  );
}
